<template>
  <b-card no-body class="mb-4 availtable datatable wizardcontent">
    <b-tabs v-model="tabIndex" pills card>
      <b-tab>
        <template #title :title-link-class="linkClass(0)">
          {{ wizard }}
        </template>
      </b-tab>
    </b-tabs>
    <b-card-footer class="mt-2 ml-1">
      <b-row>
        <b-col class="text-left">
          <div v-if="busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
          </div>
          <div v-else>
            <span v-html="message"></span>
          </div>
        </b-col>

        <b-col class="text-right" cols="12">
          <b-button
            squared
            size="sm"
            variant="secondary"
            class="mr-1"
            v-if="step > 0"
            :disabled="step == 0"
            @click="back()"
          >
            <i class="fa fa-chevron-left pr-1"></i>
            Back
          </b-button>
          <b-button
            squared
            size="sm"
            variant="primary"
            v-if="step < last"
            @click="next()"
          >
            Next
            <i class="fa fa-chevron-right pl-1"></i>
          </b-button>
          <b-button
            v-if="step == last"
            squared
            size="sm"
            variant="primary"
            @click="finish()"
          >
            <!-- <i class="fa fa-check"></i> -->
            Finish
          </b-button>
        </b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>

<script>
export default {
  name: "t-wizard",
  props: {
    refid: { type: String, default: "t-wizard" },
    busy: { type: Boolean, default: false },
    icon: { type: String, default: "fa fa-heart" },
    wizard: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      tabIndex: 0,
      step: 0,
      first: 0,
      last: 0,
      //   content: this.value
    };
  },
  watch: {
    wizard: {
      async handler(newVal, oldVal) {
        console.log("watch:wizard", newVal);
        if (newVal) {
          this.first = newval.first;
          this.last = newval.last;
        }
      },
    },
  },
  methods: {
    next() {
      this.step += 1;
      console.log("next");
    },
    back() {
      this.step -= 1;
      console.log("back");
    },
    finish() {
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>